import { appI18n, useAppTranslation } from '@flowus/common/i18n';
import { type FC } from 'react';
import { usePieChartStyle, useUpdateChartFormatStyle } from 'src/hooks/chart';
import { useChartBlockId } from '../chart-config-context';
import { CheckboxText } from 'src/views/logoff/checkbox-text';
import { MultiSwitchText } from '../multi-switch-text';
import { ChartLine } from '../../chart-line';
import { DragProgressbar } from 'src/mind-map/component/drag-progressbar';

const labelPositionData: { pos: 'outside' | 'inside'; desc: string }[] = [
  {
    pos: 'outside',
    desc: appI18n.t('editor.component.chart.chart_config_panel.style.pie_style.outside_position'),
  },
  {
    pos: 'inside',
    desc: appI18n.t('editor.component.chart.chart_config_panel.style.pie_style.inside_position'),
  },
];

export const PieStyle: FC = () => {
  const chartBlockId = useChartBlockId();
  const updateChartFormatStyle = useUpdateChartFormatStyle();
  const { pieLabelPosition, showDataLabel, pieInsideRadius, pieOutsideRadius } =
    usePieChartStyle(chartBlockId);
  const { t } = useAppTranslation();
  return (
    <>
      <CheckboxText
        className="mt-4"
        defaultChecked={showDataLabel}
        content={t('common.data_label')}
        onCheck={(checked) => {
          updateChartFormatStyle(chartBlockId, {
            showDataLabel: checked,
          });
        }}
      />
      {showDataLabel && (
        <div className="mt-4 text-t2 flex items-center justify-between">
          <div>{t('editor.component.chart.chart_config_panel.style.pie_style.label_position')}</div>
          <MultiSwitchText
            active={labelPositionData.find((v) => v.pos === pieLabelPosition)!}
            values={labelPositionData}
            onSwicth={(value) => {
              updateChartFormatStyle(chartBlockId, {
                pieLabelPosition: value.pos,
              });
            }}
          />
        </div>
      )}
      <ChartLine className="my-4" />
      <div className="text-t2-medium">
        {t('editor.component.chart.chart_config_panel.style.pie_style.radius')}
      </div>
      <div className="mt-2 text-t2 text-grey3">
        <span>
          {t('editor.component.chart.chart_config_panel.style.pie_style.pie_inner_radius')}
        </span>
        <span className="text-active_color">{pieInsideRadius}%</span>
      </div>
      <div className="pr-8">
        <DragProgressbar
          className="mt-4 p-0"
          range={{ min: 0, max: 100, step: 5 }}
          scale={pieInsideRadius}
          onZoom={(scale) => {
            updateChartFormatStyle(chartBlockId, {
              pieInsideRadius: scale,
            });
          }}
        />
      </div>
      <div className="mt-10 text-t2 text-grey3">
        <span>
          {t('editor.component.chart.chart_config_panel.style.pie_style.pie_outer_radius')}
        </span>
        <span className="text-active_color">{pieOutsideRadius}%</span>
      </div>
      <div className="pr-8">
        <DragProgressbar
          className="mt-6 p-0"
          range={{ min: 0, max: 100, step: 5 }}
          scale={pieOutsideRadius}
          onZoom={(scale) => {
            updateChartFormatStyle(chartBlockId, {
              pieOutsideRadius: scale,
            });
          }}
        />
      </div>
    </>
  );
};
